import React, { FC } from "react";
import { FooterNavigationLinkProps, NavigationLinks } from "../NavigationLinks";
import { StyledNavigation } from "./index.styled";

export interface FooterNavigationProps {
  navigation: FooterNavigationLinkProps[];
}

export const Navigation: FC<FooterNavigationProps> = ({ navigation }) => {
  return (
    <StyledNavigation data-testid="footer-navigation">
      {navigation.map((navItem, index) => (
        <NavigationLinks key={index} {...navItem} />
      ))}
    </StyledNavigation>
  );
};
